// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var WebStore = require("../../store/WebStore.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var WebTypes_View = require("../../types/WebTypes_View.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebStore_Selectors = require("../../store/WebStore_Selectors.bs.js");
var WebStore_Types_Action = require("../../store/WebStore_Types_Action.bs.js");
var BrowserComponents_Icon = require("../../../../shared-browser/src/components/BrowserComponents_Icon.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var WebComponents_ToDoTaskCard = require("../../components/WebComponents_ToDoTaskCard.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var BrowserComponents_AlertCountIndicator = require("../../../../shared-browser/src/components/BrowserComponents_AlertCountIndicator.bs.js");
var WebContainers_BusinessDashboard_ToDo_PayTips = require("./WebContainers_BusinessDashboard_ToDo_PayTips.bs.js");

function container(isActiveTab) {
  var arg = function (param, param$1) {
    return BrowserStyle.withFont(param, /* Quicksand */0, param$1, /* Bold */2);
  };
  return Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), {
                  hd: BrowserStyle.alignItems("center"),
                  tl: {
                    hd: BrowserStyle.backgroundColor(isActiveTab ? ({
                              TAG: /* Grey */2,
                              _0: /* Lightest */4
                            }) : ({
                              TAG: /* White */7,
                              _0: /* Light */2
                            })),
                    tl: {
                      hd: BrowserStyle.borderRadius(BrowserStyle.rem(0.5)),
                      tl: {
                        hd: BrowserStyle.color(isActiveTab ? ({
                                  TAG: /* Grey */2,
                                  _0: /* Dark */1
                                }) : ({
                                  TAG: /* Grey */2,
                                  _0: /* Medium */2
                                })),
                        tl: {
                          hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }));
}

var title = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.textAlign("left"),
        tl: /* [] */0
      }
    });

var Styles = {
  container: container,
  title: title
};

function WebContainers_BusinessDashboard_ToDo$Presentation$NavigationTab(Props) {
  var alertCount = Props.alertCount;
  var icon = Props.icon;
  var isActiveTab = Props.isActiveTab;
  var onClick = Props.onClick;
  var title$1 = Props.title;
  return React.createElement(BrowserComponents_Button.Base.make, {
              children: React.createElement(BrowserComponents_FlexRow.make, {
                    className: container(isActiveTab),
                    children: null
                  }, React.createElement(BrowserComponents_Icon.make, {
                        color: isActiveTab ? ({
                              TAG: /* Grey */2,
                              _0: /* Dark */1
                            }) : ({
                              TAG: /* Grey */2,
                              _0: /* Medium */2
                            }),
                        icon: {
                          TAG: /* Small */1,
                          _0: icon
                        }
                      }), React.createElement(BrowserComponents_Spacer.make, {
                        size: /* Medium */4
                      }), React.createElement(BrowserComponents_Text.make, {
                        className: title,
                        children: title$1
                      }), React.createElement(BrowserComponents_AlertCountIndicator.make, {
                        alertCount: alertCount
                      })),
              onClick: (function (param) {
                  return onClick;
                })
            });
}

var NavigationTab = {
  Styles: Styles,
  make: WebContainers_BusinessDashboard_ToDo$Presentation$NavigationTab
};

var container$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignContent("stretch"),
      tl: {
        hd: BrowserStyle.display("flex"),
        tl: {
          hd: BrowserStyle.flex({
                NAME: "num",
                VAL: 1.0
              }),
          tl: {
            hd: BrowserStyle.flexDirection(BrowserStyle.row),
            tl: {
              hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
              tl: {
                hd: BrowserStyle.minHeight(BrowserStyle.zero),
                tl: {
                  hd: BrowserStyle.mobileMedia({
                        hd: BrowserStyle.backgroundColor({
                              TAG: /* White */7,
                              _0: /* Light */2
                            }),
                        tl: {
                          hd: BrowserStyle.padding(BrowserStyle.zero),
                          tl: /* [] */0
                        }
                      }),
                  tl: {
                    hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var mobileToDoSectionListContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
      tl: /* [] */0
    });

var content = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.border({
            NAME: "rem",
            VAL: 0.0625
          }, BrowserStyle.solid, {
            TAG: /* Grey */2,
            _0: /* Lightest */4
          }),
      tl: {
        hd: BrowserStyle.borderRadius({
              NAME: "rem",
              VAL: 0.5
            }),
        tl: {
          hd: BrowserStyle.backgroundColor({
                TAG: /* White */7,
                _0: /* Light */2
              }),
          tl: {
            hd: BrowserStyle.flex({
                  NAME: "num",
                  VAL: 1.0
                }),
            tl: {
              hd: BrowserStyle.mobileMedia({
                    hd: BrowserStyle.flexDirection(BrowserStyle.column),
                    tl: {
                      hd: BrowserStyle.borderRadius(BrowserStyle.zero),
                      tl: {
                        hd: BrowserStyle.borderWidth(BrowserStyle.zero),
                        tl: /* [] */0
                      }
                    }
                  }),
              tl: /* [] */0
            }
          }
        }
      }
    });

var navigation = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.borderRight({
            NAME: "rem",
            VAL: 0.0625
          }, BrowserStyle.solid, {
            TAG: /* Grey */2,
            _0: /* Lightest */4
          }),
      tl: {
        hd: BrowserStyle.padding(BrowserStyle.Spacing.large),
        tl: {
          hd: BrowserStyle.overflowY(BrowserStyle.scroll),
          tl: {
            hd: BrowserStyle.flexBasis({
                  NAME: "rem",
                  VAL: 18.75
                }),
            tl: /* [] */0
          }
        }
      }
    });

var Styles$1 = {
  container: container$1,
  mobileToDoSectionListContainer: mobileToDoSectionListContainer,
  content: content,
  navigation: navigation
};

function WebContainers_BusinessDashboard_ToDo$Presentation(Props) {
  var currentToDoView = Props.currentToDoView;
  var navigateToPostAShift = Props.navigateToPostAShift;
  var payTips = Props.payTips;
  var payTipsAlertCount = Props.payTipsAlertCount;
  var payTipsToDos = Props.payTipsToDos;
  var responsiveLayout = Props.responsiveLayout;
  var setView = Props.setView;
  return React.createElement("main", {
              className: container$1
            }, React.createElement(BrowserComponents_FlexRow.make, {
                  className: content,
                  children: null
                }, responsiveLayout >= 2 ? React.createElement(BrowserComponents_FlexColumn.make, {
                        className: navigation,
                        children: React.createElement(WebContainers_BusinessDashboard_ToDo$Presentation$NavigationTab, {
                              alertCount: payTipsAlertCount,
                              icon: {
                                TAG: /* InputField */2,
                                _0: /* Dollar */1
                              },
                              isActiveTab: Relude_Option.fold(false, (function (param) {
                                      return true;
                                    }), currentToDoView),
                              onClick: Curry._1(setView, Relude_Option.pure(/* PayTips */{
                                        _0: undefined
                                      })),
                              title: "Pay Tips"
                            })
                      }) : null, Relude_Option.fold(responsiveLayout >= 2 ? null : React.createElement(BrowserComponents_FlexColumn.make, {
                            className: mobileToDoSectionListContainer,
                            children: React.createElement(WebComponents_ToDoTaskCard.make, {
                                  alertCount: payTipsAlertCount,
                                  description: Curry._2(Relude_Int.OrdNamed.greaterThan, 0, payTipsAlertCount) ? "You have " + (Relude_Int.toString(payTipsAlertCount) + " outstanding tips to pay.") : "All tips have been paid.",
                                  illustration: /* MoneyHandX */60,
                                  onClick: Curry._1(setView, Relude_Option.pure(/* PayTips */{
                                            _0: undefined
                                          })),
                                  title: "Pay Tips"
                                })
                          }), (function (selectedShiftId) {
                        return React.createElement(WebContainers_BusinessDashboard_ToDo_PayTips.make, {
                                    navigateToPostAShift: navigateToPostAShift,
                                    payTips: payTips,
                                    payTipsAlertCount: payTipsAlertCount,
                                    payTipsToDos: payTipsToDos,
                                    responsiveLayout: responsiveLayout,
                                    selectedShiftId: selectedShiftId._0,
                                    setView: setView
                                  });
                      }), currentToDoView)));
}

var Presentation = {
  NavigationTab: NavigationTab,
  Styles: Styles$1,
  make: WebContainers_BusinessDashboard_ToDo$Presentation
};

var mapStateToProps = Reselect.createSelector2(undefined, WebStore_Selectors.getPayTipsToDoAlertCount, WebStore_Selectors.getPayTipsToDos, (function (payTipsAlertCount, payTipsToDos) {
        return {
                payTipsAlertCount: payTipsAlertCount,
                payTipsToDos: payTipsToDos
              };
      }));

function mapDispatchToProps(dispatch) {
  var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg$1 = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg$2 = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  var partial_arg_navigateToPostAShift = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great(WebStore_Types_Action.navigateToPostAShift, dispatch, param);
                }), partial_arg, param);
  };
  var partial_arg_payTips = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great((function (param) {
                                return Relude_Globals.$great$great(WebStore_Types_Action.Dashboard.payTips, WebStore_Types_Action.dashboard, param);
                              }), dispatch, param);
                }), partial_arg$1, param);
  };
  var partial_arg_setView = function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great((function (param) {
                                return Relude_Globals.$great$great((function (param) {
                                              return Relude_Globals.$great$great(WebTypes_View.BusinessDashboard.toDo, WebTypes_View.businessDashboard, param);
                                            }), WebStore_Types_Action.setView, param);
                              }), dispatch, param);
                }), partial_arg$2, param);
  };
  var partial_arg$3 = {
    navigateToPostAShift: partial_arg_navigateToPostAShift,
    payTips: partial_arg_payTips,
    setView: partial_arg_setView
  };
  return function (param) {
    return Relude_Globals.$$const(partial_arg$3, param);
  };
}

function WebContainers_BusinessDashboard_ToDo(Props) {
  var currentToDoView = Props.currentToDoView;
  var responsiveLayout = Props.responsiveLayout;
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  return React.createElement(WebContainers_BusinessDashboard_ToDo$Presentation, {
                              currentToDoView: currentToDoView,
                              navigateToPostAShift: param$1.navigateToPostAShift,
                              payTips: param$1.payTips,
                              payTipsAlertCount: param.payTipsAlertCount,
                              payTipsToDos: param.payTipsToDos,
                              responsiveLayout: responsiveLayout,
                              setView: param$1.setView
                            });
                })
            });
}

var make = WebContainers_BusinessDashboard_ToDo;

exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* title Not a pure module */
